export default __webpack_public_path__ + "static/media/first-slide-small.769eb60e.jpg";